module.exports = __webpack_public_path__ + "d08c09f2f169f4a6edbcf8b8d1636cb4.woff2";